"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testId = exports.testIds = void 0;
var testClassPrefix = 'test.';
var generateTestIds = function (arr) {
    return arr.reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item] = testClassPrefix + item, _a)));
    }, {});
};
exports.testIds = {
    renderTags: generateTestIds(['tagsContainer', 'tagsChip']),
    renderLi: generateTestIds(['option']),
};
var testId = function (key, value) {
    var testId = exports.testIds[key][value];
    return { 'data-testid': testId };
};
exports.testId = testId;
